/**
 * Append-only note thread on an acute case. Notes are attributed to a desk
 * role, not a person — the clinic logs in per terminal.
 */

const ROLE_LABELS: Record<string, string> = {
	ordinace: 'Ordinace',
	recepce: 'Recepce',
}

export interface DeskNote {
	id: string
	authorRole: string
	text: string
	createdAt: string
}

function formatNoteTime(iso: string): string {
	const date = new Date(iso)
	const day = date.getDate()
	const month = date.getMonth() + 1
	const hours = date.getHours().toString().padStart(2, '0')
	const minutes = date.getMinutes().toString().padStart(2, '0')
	return `${day}. ${month}. ${hours}:${minutes}`
}

export function NoteThread({ notes }: { notes: DeskNote[] }) {
	if (notes.length === 0) {
		return (
			<p className="text-[13px] italic text-[#8c8275]">
				Zatím bez poznámky od ordinace.
			</p>
		)
	}

	return (
		<ul className="space-y-2.5">
			{notes.map((note) => (
				<li
					key={note.id}
					className="border-l-2 border-[#d7ad6c] pl-3 text-[13px]"
				>
					<p className="text-[11px] uppercase tracking-wide text-[#8c8275]">
						{ROLE_LABELS[note.authorRole] ?? note.authorRole} ·{' '}
						{formatNoteTime(note.createdAt)}
					</p>
					{/* whitespace-pre-wrap: the doctor's line breaks are meaningful */}
					<p className="whitespace-pre-wrap break-words text-[#3d3428]">
						{note.text}
					</p>
				</li>
			))}
		</ul>
	)
}
